import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface SalesforceConfig {
  salesforceId: string | null;
}

export const getSalesforceId = (businessId: number): AxiosPromise<SalesforceConfig> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/integrations/salesforce`,
  });
};
